import { Box, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { NavLink, NavLinkProps } from 'react-router-dom';
import { commonNavButtonStyles } from './nav-item-styles';

export type NavItemChildProps = {
  label: string;
  to: string;
  isActive?: NavLinkProps['isActive'];
  icon?: React.ReactNode;
};

export const NavItemChild = ({ label, to, isActive, icon }: NavItemChildProps) => {
  return (
    <ListItem disablePadding sx={{ display: 'block' }}>
      <ListItemButton
        component={NavLink}
        to={to}
        isActive={isActive}
        sx={[
          {
            ...commonNavButtonStyles,
            minHeight: { xs: 36, xl: 40 },
            py: 0.25,
            pl: '3.25rem', // Aligns with parent text: px: 2.5 (20px) + icon (24px) + mr: 3 (24px) = 68px = 4.25rem
            pr: 0.5,
            '& .MuiListItemText-primary': {
              fontSize: '0.8rem',
              fontWeight: 400,
            },
          },
        ]}
      >
        {icon && (
          <Box
            sx={{
              ml: -3,
              mr: 1,
              width: '16px',
              fontSize: '14px',
              opacity: 0.6,
            }}
          >
            {icon}
          </Box>
        )}
        <ListItemText primary={label} />
      </ListItemButton>
    </ListItem>
  );
};
